import { APIRegistry } from '@spothero/utils/api';
import { formatTransientSpotDetailsResponse } from '../utils/formatTransientSearchResponse';
import { transformV2SingleFacilityToV1RatesTransient } from 'api/search-v2/transient/format/format-v2-to-v1';
import SearchTracking from 'utils/search-tracking';
import { getWebExperimentCookie } from 'utils/web-experiment';
// These two are probably more widely used
// TS-migration: This needs better output typing but I(MR) dont want to double work with openAPI so leaving as is for now.
// https://api.spothero.com/v2/docs#operation/searchTransientFacilityParking|Documentation
export function getTransientFacility(facilityId, params, asV2 = false) {
    const api = APIRegistry.get('craigSearch');
    const { sessionUUID, searchUUID, actionUUID, action, } = SearchTracking.getValues();
    const fingerprint = getWebExperimentCookie();
    const response = api
        .get(`search/transient/${facilityId}`, {
        oversize: false,
        show_unavailable: true,
        session_id: sessionUUID,
        search_id: searchUUID,
        action_id: actionUUID,
        action,
        fingerprint,
        ...params,
    })
        .then(({ data: { result } }) => {
        return formatTransientSpotDetailsResponse(result, {
            eventId: params?.eventId,
            rebookId: params?.rebookId,
            // MR 10/2/2023 - Down stream this is needed, ideally we get the timezone from the spot data
            timezone: result?.facility?.common?.addresses[0]?.time_zone,
        });
    });
    if (asV2) {
        return response;
    }
    else {
        return response.then(resp => transformV2SingleFacilityToV1RatesTransient(resp));
    }
}
